<template>
  <div class="flex flex-col justify-center items-center">
    <div class="py-3 pt-4 px-10 rounded-t-box bg-base-content/10 w-full">
      <div class="tooltip" data-tip="Keys to which the rule applies">
        <span class="font-semibold">Keys</span>
      </div>
    </div>

    <div class="m-4 flex justify-center items-center gap-4">
      <span>{{ keysText }}</span>

      <KeysEdit v-model="rule.keys" />
    </div>

    <div class="py-3 px-10 bg-base-content/10 w-full">
      <div
        class="tooltip"
        data-tip="Condition required for the rule to be active"
      >
        <span class="font-semibold">Condition</span>
      </div>
    </div>

    <div class="m-4 flex justify-center items-center flex-wrap">
      <ConditionEdit
        :modelValue="modelValue.condition"
        @update:modelValue="updateCondition"
      />
    </div>

    <div class="py-3 px-10 bg-base-content/10 w-full">
      <div
        class="tooltip"
        data-tip="Color pattern used for a LED when the rule applies"
      >
        <span class="font-semibold">Pattern</span>
      </div>
    </div>

    <div class="m-4 flex flex-col justify-center items-center">
      <SettingsOption
        label="Repeat"
        tooltip="Defines how the pattern should be repeated"
        class="w-auto"
      >
        <ListSelect
          class="w-40"
          v-model="rule.pattern.repeat"
          :options="REPEAT"
          :clearable="false"
        />
      </SettingsOption>

      <SettingsOption
        label="Transitions"
        tooltip="Color transitions - transition reaches given color after some time, interpolating from current color"
        class="w-auto"
      >
      </SettingsOption>
      <!-- <span>Transitions</span> -->

      <TransitionsEdit v-model="rule.pattern.transitions" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { LedRule, Condition } from "@/keyboard";
import { keysDescription } from "@/keyboard/keys_utils";
import { REPEAT } from "@/keyboard/leds";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import ListSelect from "@/components/utils/ListSelect.vue";
import ConditionEdit from "@/components/leds/ConditionEdit.vue";
import KeysEdit from "@/components/leds/KeysEdit.vue";
import TransitionsEdit from "@/components/leds/TransitionsEdit.vue";

const props = defineProps<{
  modelValue: LedRule;
}>();

const emit = defineEmits<{
  (_e: "update:modelValue", _value: LedRule): void;
}>();

// Hacky way to avoid "unexpected property mutation" warnings when using v-model.
// It works correctly anyway, as we are accessing the reactive objects in rule's fields.
const rule = computed(() => props.modelValue);

const keys = computed(() =>
  rule.value.keys == undefined ? null : rule.value.keys
);
// TODO: add warning about no keys selected (like in keyboard config, see warnings.ts)
const keysText = computed(() => keysDescription(keys.value));

const updateCondition = (c?: Condition) => {
  console.log("updateCondition", JSON.stringify(c, null, 2));
  const rule = Object.assign({}, props.modelValue, {
    condition: c ?? "Always",
  });
  emit("update:modelValue", rule);
};
</script>
